export default "__VITE_ASSET__CTBeROya__"